import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
    FormGroup,
    Form,
    Label,
    Button
} from "reactstrap"

import Select from "react-select"

import { connect } from "react-redux";
import { useDispatch } from 'react-redux';
// import { addClass, updateClass } from './actions';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { generatePreSignedUrl } from "helpers/Content_helper";
import axios from "axios";
import { fetchAllCategory } from "helpers/category_helper";
import { fetchAllSubCategoryBasedOnCategory } from "helpers/subCategory_helper";
import { createCourse } from "helpers/course_helper";
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar } from '@syncfusion/ej2-react-richtexteditor';
import StepProgress from "components/PageComponent/StepProgress";
import { Modal } from "react-bootstrap";
import { v4 as uuidv4 } from 'uuid';
import { fetchAllLevel } from "helpers/level_helper";
import { DOWNLOAD_ASSESSMENT_QUESTION_DEMO_FILE } from "helpers/url_helper";
import { set } from "store";
const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB per chunk

const CreateCourse = (props) => {
    document.title = "Content Management | Create Course";



    const breadcrumbItems = [
        { title: "Course", link: "#" },
        { title: "Create Course", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Create Course', breadcrumbItems)
    })


    const [videoFile, setVideoFile] = useState(null);
    const [videoName, setVideoName] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const [title, setTitle] = useState("");
    const [shortDesc, setShortDesc] = useState("");
    const [description, setDescription] = useState("");
    const [textContent, setTextContext] = useState("");
    const [level, setLevel] = useState("");
    const [duration, setDuration] = useState("");
    const [language, setLanguage] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [category, setCategory] = useState(null);
    const [subCategory, setSubCategory] = useState(null);
    const [allCategories, setAllCategories] = useState([]);
    const [allSubCategories, setAllSubCategories] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);
    const [thumbnailPreview, setThumbnailPreview] = useState(null);
    const [studentBenefitsCount, setStudentBenefitsCount] = useState(1);
    const [studentBenefits, setStudentBenefits] = useState(['']);
    const [coursePrerequisitsCount, setCoursePrerequisitsCount] = useState(1);
    const [coursePrerequisits, setCoursePrerequisits] = useState(['']);
    const [editModule, setEditModule] = useState(false);
    const [addModuleModal, setAddModuleModal] = useState(false);
    const [editModuleModal, setEditModuleModal] = useState(false);
    const [moduleTitle, setModuleTitle] = useState("");
    const [moduleType, setModuleType] = useState("");
    const [moduleOrder, setModuleOrder] = useState("");
    const [allModules, setAllModules] = useState([]);
    const [moduleIndex, setModuleIndex] = useState("");
    const [editLesson, setEditLesson] = useState(false);
    const [editAssessment, setEditAssessment] = useState(false);
    const [lessonOrQuizModal, setLessonOrQuizModal] = useState(false);
    const [selectedModuleIndex, setSelectedModuleIndex] = useState(null);
    const [addLessonModal, setAddLessonModal] = useState(false);
    const [lessonTitle, setLessonTitle] = useState("");
    const [lessonContentType, setLessonContentType] = useState("");
    const [lessonContentDescription, setLessonContentDescription] = useState("");
    const [lessonUrl, setLessonUrl] = useState("");
    const [lessonDuration, setLessonDuration] = useState("");
    const [lessonContentFile, setLessonContentFile] = useState("");
    const [editLessonModal, setEditLessonModal] = useState(false);
    const [editAssessmentModal, setEditAssessmentModal] = useState(false);
    const [lessonIndex, setLessonIndex] = useState("")
    const [assessmentIndex, setAssessmentIndex] = useState("")
    const [creatorName, setCreatorName] = useState("");
    const [courseType, setCourseType] = useState(null);
    const [reviewOption, setReviewOption] = useState(null);
    const [price, setPrice] = useState(null);
    const [allLevels, setAllLevels] = useState([]);
    const [introVideo, setIntroVideo] = useState(null);
    const [assessment, setAssessment] = useState({
        title: "",
        duration: "",
        file: null,
        totalQuestions: "",
        minimumRightAnswer: "",
        warningCounts: "",

    });
    const [certificate, setCertificate] = useState(null);
    const [addAssessmentModal, setAddAssessmentModal] = useState(false);



    const lessonContentTypeData = [
        { id: 1, name: "Video" },
        { id: 2, name: "Pdf" },
        { id: 3, name: "PPT" },
    ]
    const courseTypeData = [
        { id: 1, name: "Private" },
        { id: 2, name: "Public" },
    ]
    const reviewOptionData = [
        { id: 1, name: "On" },
        { id: 2, name: "Off" },
    ]

    const languageOptionData = [
        { id: 1, name: "Hindi" },
        { id: 2, name: "English" },
        { id: 3, name: "Marathi" },
        { id: 4, name: "Gujarati" },
        { id: 5, name: "Punjabi" },
        { id: 6, name: "Tamil" },
        { id: 7, name: "Telugu" },
        { id: 8, name: "Kannada" },
        { id: 9, name: "Malayalam" },
        { id: 10, name: "Odia" },
        { id: 11, name: "Bengali" },
        { id: 12, name: "Assamese" },
        { id: 13, name: "Manipuri" },
        { id: 14, name: "Nepali" },
        { id: 15, name: "Urdu" },
    ];

    const navigate = useNavigate();

    useEffect(() => {
        /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, []);


    const getAllLevel = async () => {
        try {
            setLoader(true);
            const result = await fetchAllLevel();
            if (result?.success) {
                setAllLevels(result?.result);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }
    }


    useEffect(() => {
        getAllLevel();
    }, []);

    const handleFileChangea = (e) => {
        const file = e.target.files[0];
        console.log(file?.name);
        if (file) {
            setVideoFile(file);
            setVideoName(file?.name); // Store the file name
        } else {
            setVideoFile(null);
            setVideoName('');
        }
    };

    const uploadChunk = async (chunk, index, totalChunks) => {
        try {
            let chunkIndex = index;
            const result = await generatePreSignedUrl({ videoName, chunkIndex });
            if (result?.success) {
                const url = result?.presignedUrl;
                await axios.put(url, chunk, {
                    headers: {
                        'Content-Type': videoFile.type,
                    }
                });
            }
        } catch (error) {
            toast.error(`Failed to upload chunk ${index}: ${error?.response?.data?.message}`);
            throw error;
        }
    };

    const handleSubmit1 = async (e) => {
        e.preventDefault();
        if (!videoFile) return;

        setLoader(true);
        const totalChunks = Math.ceil(videoFile.size / CHUNK_SIZE);
        const chunkPromises = [];

        for (let i = 0; i < totalChunks; i++) {
            const start = i * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, videoFile.size);
            const chunk = videoFile.slice(start, end);

            chunkPromises.push(uploadChunk(chunk, i + 1, totalChunks));
        }

        try {
            await Promise.all(chunkPromises);
            toast.success("File Uploaded Successfully");
        } catch (error) {
            toast.error("Failed to upload the file.");
        } finally {
            setLoader(false);
        }
    };




    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();

            if (data?.success) {
                setAllCategories(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const fetchSubCategories = async (selectedValue) => {
        try {
            setLoader(true);
            const data = await fetchAllSubCategoryBasedOnCategory(selectedValue);
            setLoader(false);
            if (data?.success) {
                setAllSubCategories(data?.result);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchCategories();
    }, []);



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setThumbnail(file);

        if (file) {
            const fileURL = URL.createObjectURL(file);
            setThumbnailPreview(fileURL);
        } else {
            setThumbnailPreview(null);
        }
    };

    const handleContentFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLessonContentFile(file); // Store the file name
        } else {
            setLessonContentFile(null);
        }
    };

    const handleCategoryChange = (selectedValue) => {
        setCategory(selectedValue);
        setAllSubCategories([]);
        setSubCategory(null);
        fetchSubCategories(selectedValue)
    }


    const handleAddBenefit = () => {
        setStudentBenefitsCount(studentBenefitsCount + 1);
        setStudentBenefits([...studentBenefits, '']); // Add a new empty string to the studentBenefits array
    };

    const handleBenefitChange = (index, value) => {
        const newTitles = [...studentBenefits];
        newTitles[index] = value;
        setStudentBenefits(newTitles);
    };

    const handleAddPrerequsits = () => {
        setCoursePrerequisitsCount(coursePrerequisitsCount + 1);
        setCoursePrerequisits([...coursePrerequisits, '']); // Add a new empty string to the studentBenefits array
    };

    const handlePrerequsitsChange = (index, value) => {
        const newTitles = [...coursePrerequisits];
        newTitles[index] = value;
        setCoursePrerequisits(newTitles);
    };

    const handleAddModule = () => {

        if (!moduleTitle || !moduleType || !moduleOrder) {
            setSpanDisplay("inline")
        }
        else {
            setSpanDisplay("none")
            let mod = allModules;
            mod.push({ title: moduleTitle, type: moduleType, moduleOrder })
            setAllModules(mod);
            setAddModuleModal(false);
            setModuleTitle("");
            setModuleType("");
            setModuleOrder("");
        }

    }

    const handleUpdateModuleClick = (data, i) => {

        setEditModuleModal(true);

        setLessonIndex(i);
        setLessonTitle(data?.title);
        setLessonContentFile(data?.lessonContentFile)
        setLessonDuration(data?.duration)
        setLessonContentType()
        setModuleTitle(data?.title);
        setModuleType(data?.type);
    }


    const handleUpdateModule = async () => {
        let mod = [...allModules];
        let updatedModule = { title: moduleTitle, type: moduleType, moduleOrder }
        // Update the module at the specified index
        mod[moduleIndex] = { ...mod[moduleIndex], ...updatedModule };

        // Update the state with the modified array
        setAllModules(mod);
        setEditModuleModal(false);
        setModuleTitle("");
        setModuleType("");
        setModuleOrder("");

    }
    const handleDeleteModule = async (index) => {
        let mod = [...allModules];

        // Remove the item at the specified index
        mod.splice(index, 1);

        // Update the state with the modified array
        setAllModules(mod);
    }
    const handleDeleteLesson = async (index) => {
        let mod = [...allModules];

        // Remove the item at the specified index
        mod[selectedModuleIndex].lessons.splice(index, 1);

        // Update the state with the modified array
        setAllModules(mod);
    }



    const handleAddLesson = () => {
        let mod = [...allModules];
        let currentMod = mod[selectedModuleIndex];

        // Initialize lessons array if it doesn't exist yet
        if (!currentMod.lessons) {
            currentMod.lessons = [];
        }


        // set up the lesson description

        const res = rteObjForLessonDescritption.getContent();
        let desc = res.outerHTML;
        desc = removeSpecificDivs(desc);
        let tempElement = document.createElement('div');
        tempElement.innerHTML = res.outerHTML;
        let textCont = tempElement.textContent || tempElement.innerText;

        templateForLessonDescription = "";



        // Create a new lesson object
        let lesson = {
            title: lessonTitle,
            contentType: lessonContentType?.name,
            duration: lessonDuration,
            lessonContentFile,
            lessonDescription: desc,
            lessonDescriptionContent: textCont
        };

        console.log("lesson", lesson)
        // Add the new lesson to the lessons array
        currentMod.lessons.push(lesson);

        // Update the module in the array
        mod[selectedModuleIndex] = { ...mod[selectedModuleIndex], ...currentMod };

        // Update the state with the modified array
        setAllModules(mod);

        // Close the modal and reset the lesson form fields
        setAddLessonModal(false);
        setLessonTitle("");
        setLessonContentFile(null);
        setLessonContentType(null);
        setLessonDuration("");
        setLessonUrl("");
        templateForLessonDescription = "";
    };

    const handleUpdateLessonClick = (data, i) => {

        setEditLessonModal(true);
        console.log(data)
        setLessonIndex(i);
        setLessonTitle(data?.title);
        setLessonDuration(data?.duration)
        setLessonContentFile(data?.lessonContentFile)
        templateForLessonDescription = data?.lessonDescription;
        const selectedContentType = lessonContentTypeData.find(
            (contentType) => contentType.name === data?.contentType
        );
        setLessonContentType(selectedContentType);
    }



    const handleUpdateLesson = () => {
        let mod = [...allModules];

        // set up the lesson description

        const res = rteObjForLessonDescritption.getContent();
        let desc = res.outerHTML;
        desc = removeSpecificDivs(desc);
        let tempElement = document.createElement('div');
        tempElement.innerHTML = res.outerHTML;
        let textCont = tempElement.textContent || tempElement.innerText;


        let updateLesson = {
            title: lessonTitle,
            contentType: lessonContentType?.name,
            duration: lessonDuration,
            lessonContentFile,
            lessonDescription: desc,
            lessonDescription: textCont
        };

        // Corrected line: Use 'lessons' instead of 'lesson'
        mod[selectedModuleIndex].lessons[lessonIndex] = {
            ...mod[selectedModuleIndex].lessons[lessonIndex],
            ...updateLesson
        };


        // Update the state with the modified array
        setAllModules(mod);

        // Close the modal and reset the lesson form fields
        setEditLessonModal(false);
        setLessonTitle("");
        setLessonContentFile(null);
        setLessonContentType(null);
        setLessonDuration("");
        setLessonUrl("");
        templateForLessonDescription = "";
    };






    // functions for uploading data 


    const uploadData = (file, type) => {
        console.log("Entering uploadData");
        return new Promise(async (resolve, reject) => {
            try {
                const name = uuidv4() + '.' + file.name.split('.').pop();
                // Request a pre-signed URL from the backend
                console.log("name ---> ", name);
                const result = await generatePreSignedUrl({ name, type });

                if (result?.success) {
                    const url = result?.presignedUrl; // Assuming your backend returns URL and headers for PUT request
                    console.log("Presigned URL: ", url);

                    // Upload the file to S3 using the pre-signed URL
                    const res = await axios.put(url, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    });
                    console.log("s3 Upload result: ", res);

                    resolve(name);
                } else {
                    reject(result?.message || 'Failed to get pre-signed URL.');
                }
            } catch (error) {
                console.error('Upload error:', error); // Log the error for debugging
                reject('Error uploading the file.');
            }
        });
    };


    function removeSpecificDivs(htmlString) {
        // Parse the HTML string into a new DOM document
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Selectors for the divs to remove based on class and id
        const selectorsToRemove = [
            'div.e-rte-content#defaultRTErte-view',
            'div.e-content.e-lib.e-keyboard#defaultRTE_rte-edit-view'
        ];

        // Iterate over selectors and remove the matching elements
        selectorsToRemove.forEach(selector => {
            const elements = doc.querySelectorAll(selector);
            elements.forEach(element => {
                // Instead of removing the element, we replace it with its content
                while (element.firstChild) {
                    element.parentNode.insertBefore(element.firstChild, element);
                }
                element.parentNode.removeChild(element);
            });
        });

        // Serialize the updated DOM back to a string
        // Inner HTML of the body will contain the expected output
        return doc.body.innerHTML;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);

        try {
            const updatedModules = await Promise.all(
                allModules.map(async (module) => {
                    const updatedLessons = await Promise.all(
                        module.lessons.map(async (lesson) => {
                            try {
                                // Check if lesson has a file to upload
                                if (lesson.lessonContentFile) {
                                    console.log("fdlkfldkfldkfl")
                                    const url = await uploadData(lesson.lessonContentFile, lesson.contentType);
                                    // const url = "";
                                    const { lessonContentFile, ...updatedLesson } = lesson;

                                    console.log("updatedLesson without file ", updatedLesson);

                                    return { ...updatedLesson, url: url }; // Add the URL to the lesson

                                }
                                return lesson; // Return the lesson as is if no file
                            } catch (error) {
                                console.error('Lesson upload error:', error); // Log the error for debugging
                                toast.error(error);
                                return lesson; // Return the lesson as is in case of an error
                            }
                        })
                    );
                    return { ...module, lessons: updatedLessons };
                })
            );

            // You may want to send the updatedModules to the backend here
            // await axios.post('/api/save-modules', { modules: updatedModules });

            // get description from the text editor 

            let introVideoUrl = "";
            let certificateUrl = "";
            let thumbnailUrl = "";

            if (introVideo) {
                introVideoUrl = await uploadData(introVideo, 'Video');
            }
            if (certificate) {
                certificateUrl = await uploadData(certificate, 'Pdf');
            }

            if (thumbnail) {
                thumbnailUrl = await uploadData(thumbnail, 'image');
            }

            // const introVideoUrl = "";
            // const certificateUrl = "";
            // const thumbnailUrl = "";





            const formData = new FormData();
            formData.append('title', title);
            formData.append('shortDesc', shortDesc);
            formData.append('introVideo', introVideoUrl);
            formData.append('certificate', certificateUrl);
            formData.append('level', JSON.stringify(level));
            formData.append('description', description);
            formData.append('textContent', textContent);
            formData.append('language', language.name);
            formData.append('duration', duration);
            formData.append('category', JSON.stringify(category));
            formData.append('subCategory', JSON.stringify(subCategory));
            formData.append('creatorName', creatorName);
            formData.append('courseType', courseType.name);
            formData.append('reviewOption', reviewOption.name);
            formData.append('price', price);

            // Append studentBenefits and coursePrerequisits as JSON strings
            formData.append('studentBenefits', JSON.stringify(studentBenefits));
            formData.append('coursePrerequisits', JSON.stringify(coursePrerequisits));

            // Append allModules as JSON string
            formData.append('allModules', JSON.stringify(updatedModules));




            updatedModules.forEach((module, moduleIndex) => {
                // Loop through assessments in this module
                console.log("module.assessment ", module.assessment)
                console.log("moduleIndex ", moduleIndex)
                if (module.assessment) {
                    module.assessment.forEach((assessment, assessmentIndex) => {
                        // Append the Excel file for each assessment if available
                        if (assessment.file) {
                            formData.append(`assessmentFiles[${assessmentIndex}]`, assessment.file);
                        }
                    });
                }

            });

            if (thumbnail) {
                formData.append('thumbnail', thumbnailUrl);
            }

            const result = await createCourse(formData);
            // let result;
            if (result?.success) {

                toast.success(result?.message);
                navigate("/all-courses")
            }
            else {
                toast.error(result?.message);
            }


        } catch (error) {
            console.error('Handle submit error:', error); // Log the error for debugging
            toast.error(error?.response?.data?.message || 'Error processing the request.');
        } finally {
            setLoader(false);
        }
    };

    const handleTest = () => {
        if (currentStep == 0) {
            const rteValue = rteObj.getContent();
            const res = rteObj.getContent();
            let desc = res.outerHTML;
            desc = removeSpecificDivs(desc);
            let tempElement = document.createElement('div');
            tempElement.innerHTML = res.outerHTML;
            let textCont = tempElement.textContent || tempElement.innerText;

            setDescription(desc);
            setTextContext(textCont);
        }

    }


    // Function for Assessment handling

    const handleAddAssessment = () => {
        let mod = [...allModules];
        let currentMod = mod[selectedModuleIndex];

        // Initialize assessment array if it doesn't exist yet
        if (!currentMod.assessment) {
            currentMod.assessment = [];
        }

        currentMod.assessment.push(assessment);

        mod[selectedModuleIndex] = { ...mod[selectedModuleIndex], ...currentMod }; // Update the current module in the array

        setAllModules(mod);

        setAssessment({
            title: "",
            duration: "",
            file: null,
            totalQuestions: "",
            minimumRightAnswer: "",
            warningCounts: "",

        });
        setAddAssessmentModal(false);
    }

    const handleAssessmentFileChange = (e) => {
        const file = e.target.files[0]; // get the selected file

        // Check if it's an Excel file
        const fileType = file?.type;
        if (fileType === "application/vnd.ms-excel" || fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            // Process the Excel file

            setAssessment({ ...assessment, file: file });  // Store the Excel file in the state
        } else {
            // Reject non-Excel files
            toast.warning("Please upload only Excel files (.xls, .xlsx)");
            setAssessment({ ...assessment, file: null }); // Clear any previously set file if it's not Excel
        }

    };

    const handleDownloadDemoAssessmentFile = async () => {
        try {
            setLoader(true);
            const response = await axios.get(DOWNLOAD_ASSESSMENT_QUESTION_DEMO_FILE, {
                responseType: 'blob' // Set response type to 'blob' to receive binary data
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            // Create a URL for the blob data
            const url = window.URL.createObjectURL(blob);

            // Create a link element
            const link = document.createElement('a');
            link.href = url;

            // Specify the filename for the downloaded file
            link.setAttribute('download', 'question_file_format.xlsx');

            // Append the link to the body
            document.body.appendChild(link);

            // Click the link to trigger the download
            link.click();

            // Clean up: remove the link and revoke the URL object
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");

        } finally {
            setLoader(false);
        }
    }

    const handleUpdateAssessmentClick = (data, i) => {
        setEditAssessmentModal(true);
        console.log(data);
        setAssessmentIndex(i);
        setAssessment(data);
    }

    const handleUpdateAssessment = () => {
        let mod = [...allModules];

        mod[selectedModuleIndex].assessment[assessmentIndex] = {
            ...mod[selectedModuleIndex].assessment[assessmentIndex],
            ...assessment
        };

        // Update the state with the modified array
        setAllModules(mod);

        // Close the modal and reset the lesson form fields
        setEditAssessmentModal(false);
        setAssessment({
            title: "",
            duration: "",
            file: null,
            totalQuestions: "",
            minimumRightAnswer: "",
            warningCounts: "",
        });

    }

    const handleDeleteAssessment = async (index) => {
        let mod = [...allModules];
        mod[selectedModuleIndex].assessment.splice(index, 1);
        setAllModules(mod);
    }

    // ***** code for rich text editor textarea ****************


    const toolbarSettings = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', '|',
            'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
            'SourceCode', '|', 'Undo', 'Redo']
    };
    const quickToolbarSettings = {
        image: ['Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-', 'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'],
        link: ['Open', 'Edit', 'UnLink']
    };

    let rteObj;
    let rteObjForLessonDescritption;

    // set the value to Rich Text Editor
    // let template = `<div style="display:block;"><p style="margin-right:10px"></p></div>`;
    let template = "";
    let templateForLessonDescription = "";

    // Rich Text Editor items list
    let items = ['Bold', 'Italic', 'Underline', '|', 'Formats', 'Alignments', 'OrderedList',
        'UnorderedList', '|', 'CreateLink', 'Image', '|', 'SourceCode', '|', 'Undo', 'Redo'
    ];


    const htmlString = '<div class="e-rte-content" id="defaultRTErte-view" style="height: auto; margin-top: 0px; border-bottom: none;"><div class="e-content e-lib e-keyboard" id="defaultRTE_rte-edit-view" contenteditable="true" tabindex="0"><div style="display:block;"><p> </p><p style="margin-right: 10px; text-align: center;"><span style="font-size: 14pt;"><span style="font-family: &quot;Times New Roman&quot;, Times, serif;"><strong><span style="text-decoration: underline;"><span style="text-decoration: line-through;">dfkfdlfkdlkfdlfkdkfjdkf</span></span> fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c</strong></span></span></p><p style="margin-right:10px"> </p><ul><li style="margin-right:10px"><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont; background-color: unset; text-align: inherit;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,ewewew</span></li></ul><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv</span></div><ul><li style="display:block;"><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c klklk</span><p style="margin-right: 10px; cursor: auto;"><img src="blob:http://localhost:3000/5a96c08a-fe90-4ee0-9d74-83bb7376a00e" class="e-rte-image e-imginline" alt="Screenshot (648).png" width="126" height="auto" style="min-width: 20px; min-height: 0px;">  </p><ul><li style="list-style-type: none;"><ul><li style="list-style-type: none;"><ul><li><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c</span><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont; background-color: unset; text-align: inherit;"> </span></li></ul></li></ul></li></ul></li></ul></div></div>';

    const htmlContent = { __html: htmlString };


    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col>
                    <Card>

                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Create Course</CardTitle>
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <div className="mt-2">
                                        <div>
                                            <StepProgress currentStep={currentStep} />
                                            {/* Navigation Buttons */}
                                            {/* <button onClick={() => setCurrentStep(currentStep - 1)} disabled={currentStep === 0}>
                                                Previous
                                            </button>
                                            <button onClick={() => setCurrentStep(currentStep + 1)} disabled={currentStep === 3}>
                                                Next
                                            </button> */}
                                        </div>
                                    </div>
                                </Row>

                                {currentStep == 0 && (


                                    <Row className="mb-3" >
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Title
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control p-2"
                                                placeholder="Enter new title"
                                                value={title}
                                                maxLength="50"
                                                onChange={(e) => setTitle(e.target.value)}
                                                style={{ border: ".5px solid #bbb3b3" }}

                                            />
                                            {!title && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Level
                                            </label>
                                            <Select

                                                value={level}
                                                onChange={(selectedValue) => setLevel(selectedValue)}
                                                options={allLevels}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999, // Set a high z-index value
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999, // Ensure the control itself has a high z-index
                                                    }),
                                                }}
                                            />
                                            {!level && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>

                                        <div className="col-md-12 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Short Description
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control p-2"
                                                placeholder="Enter short description"
                                                value={shortDesc}
                                                maxLength="70"  // Set maximum character limit to 70
                                                onChange={(e) => setShortDesc(e.target.value)}
                                                style={{ border: ".5px solid #bbb3b3" }}
                                            />
                                            {!shortDesc && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-12 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Description
                                            </label>
                                            <div className="">

                                                <RichTextEditorComponent id="defaultRTE" ref={(scope) => { rteObj = scope; }} valueTemplate={template} toolbarSettings={toolbarSettings}>
                                                    <Inject services={[HtmlEditor, Toolbar, Link, Image, QuickToolbar]} />
                                                </RichTextEditorComponent>
                                                {!description && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block", zIndex: "100" }}
                                            >
                                                Language
                                            </label>
                                            <Select

                                                value={language}
                                                onChange={(selectedValue) => setLanguage(selectedValue)}
                                                options={languageOptionData}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"

                                            />
                                            {!language && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Duration Of Course
                                            </label>
                                            <input type="number"
                                                className='form-control p-2'
                                                placeholder="Enter Duration in Hours"
                                                value={duration}
                                                onChange={(e) => setDuration(e.target.value)}
                                                style={{ border: ".5px solid #bbb3b3" }} />
                                            {!duration && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Category
                                            </label>
                                            <Select

                                                value={category}
                                                onChange={handleCategoryChange}
                                                options={allCategories}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"
                                            />
                                            {!category && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Sub Category
                                            </label>
                                            <Select

                                                value={subCategory}
                                                onChange={(selectedValue) => setSubCategory(selectedValue)}
                                                options={allSubCategories}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"
                                            />
                                            {!subCategory && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-12 mt-3">
                                            <label htmlFor="thumbnail-upload" className="form-label" style={{ display: "block" }}>
                                                Thumbnail
                                            </label>

                                            <div className="custom-file-upload">
                                                <input
                                                    type="file"
                                                    id="thumbnail-upload"
                                                    className="file-input"
                                                    onChange={handleFileChange}
                                                    accept="image/*"
                                                />
                                                <label htmlFor="thumbnail-upload" className="upload-label">
                                                    {thumbnailPreview && (
                                                        <div className="mt-3">
                                                            <img src={thumbnailPreview} alt="Thumbnail Preview" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                                                        </div>
                                                    )}
                                                    {!thumbnailPreview && (
                                                        <>
                                                            <i className="fas fa-upload"></i> Upload Thumbnail
                                                        </>
                                                    )}
                                                </label>
                                            </div>



                                            {!thumbnail && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>

                                    </Row>
                                )}

                                {currentStep == 1 && (
                                    <Row className="mb-3">
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                What are the benefits of the Student in this course?
                                            </label>

                                            {Array.from({ length: studentBenefitsCount }).map((_, index) => (
                                                <div key={index} className="mb-2">
                                                    <input
                                                        id={`benefit-${index}`}
                                                        type="text"
                                                        className="form-control p-2"
                                                        placeholder="Enter new title"
                                                        value={studentBenefits[index] || ''}
                                                        onChange={(e) => handleBenefitChange(index, e.target.value)}
                                                        style={{ border: ".5px solid #bbb3b3" }}
                                                    />
                                                    {!studentBenefits[index] && (
                                                        <span style={{ color: "red", display: spanDisplay }}>
                                                            This field is required
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                className="btn"
                                                onClick={handleAddBenefit}
                                                style={{ fontSize: "1rem" }}
                                            >
                                                <i class="fa-solid fa-circle-plus"></i>
                                            </button>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                What are the prerequisities for starting this course?
                                            </label>

                                            {Array.from({ length: coursePrerequisitsCount }).map((_, index) => (
                                                <div key={index} className="mb-2">
                                                    <input
                                                        id={`benefit-${index}`}
                                                        type="text"
                                                        className="form-control p-2"
                                                        placeholder="Enter new title"
                                                        value={coursePrerequisits[index] || ''}
                                                        onChange={(e) => handlePrerequsitsChange(index, e.target.value)}
                                                        style={{ border: ".5px solid #bbb3b3" }}
                                                    />
                                                    {!coursePrerequisits[index] && (
                                                        <span style={{ color: "red", display: spanDisplay }}>
                                                            This field is required
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                            <button
                                                type="button"
                                                className="btn"
                                                onClick={handleAddPrerequsits}
                                                style={{ fontSize: "1rem" }}
                                            >
                                                <i class="fa-solid fa-circle-plus"></i>
                                            </button>
                                        </div>

                                    </Row>


                                )}

                                {currentStep == 2 && (

                                    <Row className="mb-3">
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-end">
                                                <Button type="button" color="" className="ms-2 waves-effect waves-light align-self-end" onClick={() => setEditModule(prevState => !prevState)} style={{ padding: ".2rem" }} >{editModule ? <i class="fa-solid fa-circle-check" style={{ fontSize: "2rem", padding: ".5rem 0", color: "skyblue" }}></i> : <i className="mdi mdi-file-edit " style={{ fontSize: "2rem", color: "skyblue" }}></i>}</Button>

                                                <Button type="button" color="" className="ms-2 waves-effect waves-light align-self-end" onClick={() => setAddModuleModal(true)} style={{ padding: ".2rem" }} ><i className="mdi mdi-plus-circle-outline " style={{ fontSize: "2rem", color: "#29e767  " }}></i></Button>
                                            </div>

                                            <div className="accordion" id="accordionExample">
                                                {allModules?.map((d, i) => (
                                                    <>

                                                        <div className="accordion-item" key={i}>
                                                            <h2 className="accordion-header" id={`heading${i}`}>
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#collapse${i}`}
                                                                    aria-expanded={i === 0 ? "true" : "false"}
                                                                    aria-controls={`collapse${i}`}>
                                                                    {d.title} ({d.type})
                                                                    {editModule &&
                                                                        <>
                                                                            <button type='button' onClick={() => handleUpdateModuleClick(d, i)} className="warning" style={{ fontSize: "1.5rem", background: "none", border: "none", fontWeight: "bolder", }}> <i className="mdi mdi-pencil "></i></button>
                                                                            <button type='button' onClick={() => handleDeleteModule(i)} className="text-danger" style={{ fontSize: "1.5rem", background: "none", border: "none", fontWeight: "bolder", }}> <i className="mdi mdi-delete "></i></button>
                                                                        </>
                                                                    }
                                                                </button>
                                                            </h2>
                                                            <div
                                                                id={`collapse${i}`}
                                                                className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                                                                aria-labelledby={`heading${i}`}
                                                                data-bs-parent="#accordionExample">
                                                                <div className="accordion-body">
                                                                    <div className="d-flex justify-content-end">
                                                                        <button
                                                                            type="button"
                                                                            className="btn"
                                                                            onClick={() => { setEditLesson(prevState => !prevState); setSelectedModuleIndex(i) }}
                                                                            style={{ fontSize: "1rem" }}
                                                                        >

                                                                            {editLesson
                                                                                ?
                                                                                <i class="fa-solid fa-check"></i>
                                                                                :
                                                                                <i class="fa-solid fa-pen-to-square"></i>
                                                                            }
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn"
                                                                            onClick={() => { setLessonOrQuizModal(true); setSelectedModuleIndex(i) }}
                                                                            style={{ fontSize: "1rem" }}
                                                                        >
                                                                            <i class="fa-solid fa-circle-plus"></i>
                                                                        </button>

                                                                    </div>
                                                                    {d?.lessons?.map((lessonData, i) => (
                                                                        <>
                                                                            <div className="" style={{ borderBottom: "1px solid gray", borderRadius: "1rem", padding: ".5rem" }}>
                                                                                {lessonData.contentType == "Video" && (

                                                                                    <i class="fa-solid fa-video" style={{ fontSize: "1rem" }}></i>
                                                                                )}
                                                                                {lessonData.contentType == "Pdf" && (

                                                                                    <i class="fa-solid fa-file-pdf" style={{ fontSize: "1rem" }}></i>
                                                                                )}
                                                                                {lessonData.contentType == "PPT" && (

                                                                                    <i class="fa-solid fa-file-powerpoint" style={{ fontSize: "1rem" }}></i>
                                                                                )}

                                                                                {`  `}{lessonData?.title} ({lessonData?.duration} min)

                                                                                {editLesson &&
                                                                                    <>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn"
                                                                                            onClick={() => handleUpdateLessonClick(lessonData, i)}
                                                                                        // style={{ fontSize: "1rem" }}
                                                                                        >
                                                                                            <i class="fa-solid fa-pen" ></i>
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn"
                                                                                            onClick={() => handleDeleteLesson(i)}
                                                                                        // style={{ fontSize: "1rem" }}
                                                                                        >
                                                                                            <i class="fa-solid fa-trash" ></i>
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    ))}

                                                                    {d?.assessment?.map((assessmentData, i) => (
                                                                        <>
                                                                            <div className="" style={{ borderBottom: "1px solid gray", borderRadius: "1rem", padding: ".5rem" }}>


                                                                                <i class="fa-solid fa-clipboard-check" style={{ fontSize: "1rem" }}></i>




                                                                                {`  `}{assessmentData?.title} ({assessmentData?.duration} min)

                                                                                {editLesson &&
                                                                                    <>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn"
                                                                                            onClick={() => handleUpdateAssessmentClick(assessmentData, i)}
                                                                                        // style={{ fontSize: "1rem" }}
                                                                                        >
                                                                                            <i class="fa-solid fa-pen" ></i>
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn"
                                                                                            onClick={() => handleDeleteAssessment(i)}
                                                                                        // style={{ fontSize: "1rem" }}
                                                                                        >
                                                                                            <i class="fa-solid fa-trash" ></i>
                                                                                        </button>
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    ))}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>

                                                ))}
                                            </div>



                                        </div>
                                    </Row>

                                )}

                                {currentStep == 3 && (


                                    <Row className="mb-3">
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Creator Name

                                            </label>
                                            <input
                                                type="text"
                                                className="form-control p-2"
                                                placeholder="Enter Creator Name"
                                                value={creatorName}
                                                maxLength="50"
                                                onChange={(e) => setCreatorName(e.target.value)}
                                                style={{ border: ".5px solid #bbb3b3" }}

                                            />
                                            {!creatorName && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Course Type
                                            </label>
                                            <Select

                                                value={courseType}
                                                onChange={(selectedValue) => setCourseType(selectedValue)}
                                                options={courseTypeData}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"

                                            />
                                            {!courseType && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block" }}
                                            >
                                                Review Option
                                            </label>
                                            <Select

                                                value={reviewOption}
                                                onChange={(selectedValue) => setReviewOption(selectedValue)}
                                                options={reviewOptionData}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                                classNamePrefix="select2-selection"

                                            />
                                            {!reviewOption && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>

                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block", zIndex: "100" }}
                                            >
                                                Price
                                            </label>
                                            <input type="number"
                                                className='form-control p-2'
                                                placeholder="Enter Course Price"
                                                value={price}
                                                onChange={(e) => { setPrice(e.target.value) }}
                                                style={{ border: ".5px solid #bbb3b3" }} />
                                            {!price && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block", zIndex: "100" }}
                                            >
                                                Certificate
                                            </label>
                                            <input
                                                type="file"
                                                className="form-control p-2"
                                                id="certificate-input"
                                                accept="application/pdf"
                                                onChange={(e) => { setCertificate(e.target.files[0]) }}
                                                style={{ border: ".5px solid #bbb3b3" }}
                                            />
                                            {!certificate && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <label
                                                htmlFor="example-text-input"
                                                className="form-label"
                                                style={{ display: "block", zIndex: "100" }}
                                            >
                                                Intro Video
                                            </label>
                                            <input
                                                type="file"
                                                className="form-control p-2"
                                                id="demo-video-input"
                                                accept="video/*"
                                                onChange={(e) => { setIntroVideo(e.target.files[0]) }}
                                                style={{ border: ".5px solid #bbb3b3" }}
                                            />
                                            {!introVideo && (
                                                <span style={{ color: "red", display: spanDisplay }}>
                                                    This field is required
                                                </span>
                                            )}
                                        </div>


                                    </Row>
                                )}


                                <Row className="mb-3">
                                    <div className={`d-flex ${currentStep === 0 ? 'justify-content-end' : 'justify-content-between'}`}>
                                        {currentStep == 3 ?
                                            <>
                                                <div className="">

                                                    <button type="button" className="btn btn-primary w-md" onClick={() => setCurrentStep(currentStep - 1)}>Prev</button>
                                                    <button type="submit" className="btn btn-primary w-md ms-2">Create</button>
                                                </div>
                                            </>
                                            :
                                            <>
                                                {!currentStep == 0 && (

                                                    <button type="button" className="btn btn-primary w-md" onClick={() => setCurrentStep(currentStep - 1)} disabled={currentStep === 3}>Prev</button>
                                                )}
                                                <button type="button" className="btn btn-primary w-md" onClick={() => { handleTest(); setCurrentStep(currentStep + 1); }} disabled={currentStep === 3}>Save and Continue</button>
                                            </>
                                        }
                                    </div>
                                </Row>
                            </form>

                        </CardBody>


                    </Card>
                </Col>
            </Row>


            {/* Modal for create module  */}
            <Modal
                show={addModuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Module
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={moduleTitle}
                                maxLength="50"
                                onChange={(e) => setModuleTitle(e.target.value)} />
                            {!moduleTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Type
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Type"
                                value={moduleType}
                                maxLength="50"
                                onChange={(e) => setModuleType(e.target.value)} />
                            {!moduleType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Order
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Module Order"
                                value={moduleOrder}
                                maxLength="50"
                                onChange={(e) => setModuleOrder(e.target.value)}
                            />
                            {!moduleOrder && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddModuleModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddModule} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for update module  */}
            <Modal
                show={editModuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Module
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={moduleTitle}
                                maxLength="50"
                                onChange={(e) => setModuleTitle(e.target.value)} />
                            {!moduleTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Type
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Type"
                                value={moduleType}
                                maxLength="50"
                                onChange={(e) => setModuleType(e.target.value)} />
                            {!moduleType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Order
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Module Order"
                                value={moduleOrder}
                                maxLength="50"
                                onChange={(e) => setModuleOrder(e.target.value)}
                            />
                            {!moduleOrder && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditModuleModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateModule} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for select Lesson or quiz  */}
            <Modal
                show={lessonOrQuizModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Select One
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>




                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <Button type="button" color="info" onClick={() => { setAddLessonModal(true); setLessonOrQuizModal(false) }} className="waves-effect waves-light " style={{ width: "10rem " }}>Create Lesson</Button>{" "}
                        <Button type="button" color="info" onClick={() => { setAddAssessmentModal(true); setLessonOrQuizModal(false) }} className="waves-effect waves-light mt-2" style={{ width: "10rem " }}>Create Assessment</Button>{" "}
                    </div>



                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setLessonOrQuizModal(false)} className="waves-effect waves-light">Close</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for update Lesson  */}
            <Modal
                show={editLessonModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Lesson
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={lessonTitle}
                                maxLength="50"
                                onChange={(e) => setLessonTitle(e.target.value)} />
                            {!setLessonTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Content Type
                        </label>
                        <div className="col-md-10">


                            <Select

                                value={lessonContentType}
                                onChange={(selectedOption) => setLessonContentType(selectedOption)}
                                options={lessonContentTypeData}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!lessonContentType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Lesson Duration in Minutes"
                                value={lessonDuration}
                                maxLength="50"
                                onChange={(e) => setLessonDuration(e.target.value)}
                            />
                            {!lessonDuration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select Content
                        </label>
                        <div className="col-md-10">


                            <input
                                type="file"
                                className='form-control'
                                placeholder="select the content"
                                accept="video/*,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                onChange={handleFileChange}
                            />
                            {!lessonContentFile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-12 col-form-label"
                        >
                            Enter Content Description
                        </label>
                        <div className="">

                            <RichTextEditorComponent id="defaultRTE" ref={(scope) => { rteObjForLessonDescritption = scope; }} valueTemplate={template} toolbarSettings={toolbarSettings}>
                                <Inject services={[HtmlEditor, Toolbar, Link, Image, QuickToolbar]} />
                            </RichTextEditorComponent>
                            {!lessonContentDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>



                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditLessonModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateLesson} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal>



            {/* Modal for create lesson  */}
            <Modal
                show={addLessonModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Lesson
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={lessonTitle}
                                maxLength="50"
                                onChange={(e) => setLessonTitle(e.target.value)} />
                            {!setLessonTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Content Type
                        </label>
                        <div className="col-md-10">


                            <Select

                                value={lessonContentType}
                                onChange={(selectedOption) => setLessonContentType(selectedOption)}
                                options={lessonContentTypeData}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!lessonContentType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Lesson Duration in Minutes"
                                value={lessonDuration}
                                maxLength="50"
                                onChange={(e) => setLessonDuration(e.target.value)}
                            />
                            {!lessonDuration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select Content
                        </label>
                        <div className="col-md-10">


                            <input
                                type="file"
                                className='form-control'
                                placeholder="select the content"
                                accept="video/*,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                onChange={(handleContentFileChange)}
                            />
                            {!lessonContentFile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-12 col-form-label"
                        >
                            Enter Content Description
                        </label>
                        <div className="">

                            <RichTextEditorComponent id="defaultRTE" ref={(scope) => { rteObjForLessonDescritption = scope; }} valueTemplate={template} toolbarSettings={toolbarSettings}>
                                <Inject services={[HtmlEditor, Toolbar, Link, Image, QuickToolbar]} />
                            </RichTextEditorComponent>
                            {!lessonContentDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddLessonModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddLesson} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for create Assessment  */}
            <Modal
                show={addAssessmentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Assessment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row>
                        <div className="d-flex justify-content-end mb-3">
                            <button type="submit" className="btn btn-info w-md" onClick={handleDownloadDemoAssessmentFile}>Download Demo File</button>
                        </div>
                    </Row>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new title"
                                value={assessment.title}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, title: e.target.value })} />
                            {!assessment.title && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter assessment duration in minutes"
                                value={assessment.duration}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, duration: e.target.value })}
                            />
                            {!assessment.duration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Total Questions
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter total questions"
                                value={assessment.totalQuestions}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, totalQuestions: e.target.value })}
                            />
                            {!assessment.totalQuestions && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-3 col-form-label"
                        >
                            Minimum Qualify Question
                        </label>
                        <div className="col-md-9">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter minimum qualify qustions"
                                value={assessment.minimumRightAnswer}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, minimumRightAnswer: e.target.value })}
                            />
                            {!assessment.minimumRightAnswer && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Warning Count
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter total warnings"
                                value={assessment.warningCounts}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, warningCounts: e.target.value })}
                            />
                            {!assessment.warningCounts && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select File
                        </label>


                        <div className="col-md-10">
                            <input
                                type="file"
                                accept='.xlsx'
                                name='xlsxFile'
                                id='xlsxFile'
                                placeholder='Upload a File'
                                className='form-control form-control-file'
                                data-buttonname="btn-secondary"
                                onChange={handleAssessmentFileChange} />
                            {!assessment.file && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

                        </div>

                    </Row>






                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddAssessmentModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddAssessment} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal>

            {/* Modal for update Assessment  */}
            <Modal
                show={editAssessmentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Assessment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <Row>
                        <div className="d-flex justify-content-end mb-3">
                            <button type="submit" className="btn btn-info w-md" onClick={handleDownloadDemoAssessmentFile}>Download Demo File</button>
                        </div>
                    </Row>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new title"
                                value={assessment.title}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, title: e.target.value })} />
                            {!assessment.title && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter assessment duration in minutes"
                                value={assessment.duration}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, duration: e.target.value })}
                            />
                            {!assessment.duration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Total Questions
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter total questions"
                                value={assessment.totalQuestions}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, totalQuestions: e.target.value })}
                            />
                            {!assessment.totalQuestions && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-3 col-form-label"
                        >
                            Minimum Qualify Question
                        </label>
                        <div className="col-md-9">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter minimum qualify qustions"
                                value={assessment.minimumRightAnswer}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, minimumRightAnswer: e.target.value })}
                            />
                            {!assessment.minimumRightAnswer && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Warning Count
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter total warnings"
                                value={assessment.warningCounts}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, warningCounts: e.target.value })}
                            />
                            {!assessment.warningCounts && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select File
                        </label>


                        <div className="col-md-10">
                            <input
                                type="file"
                                accept='.xlsx'
                                name='xlsxFile'
                                id='xlsxFile'
                                placeholder='Upload a File'
                                className='form-control form-control-file'
                                data-buttonname="btn-secondary"
                                onChange={handleAssessmentFileChange} />
                            {!assessment.file && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

                        </div>

                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditAssessmentModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateAssessment} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateCourse);